export default __webpack_public_path__ + "static/media/mockup-light.e4b2d302.png";